var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding":"30px"}},[_c('a-row',{attrs:{"gutter":10}},[_c('a-col',{staticStyle:{"margin-bottom":"10px"},attrs:{"span":24}})],1),_c('a-row',{attrs:{"gutter":10}},[_c('a-col',{attrs:{"span":24}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }